<template>
    <div id="app">

        <div class="s-main-content">
             <transition-page>
            <router-view />
             </transition-page>
        </div>
    </div>
</template>

<script>

import TransitionPage from '@/components/Transition.vue';

export default {
    name: 'App',

    components:{
        TransitionPage
    },



    data: () => ({

        has_visited: false
    }),

    methods: {
        get_data() {
            return;
        }
    },

    created() {
        this.$root.s3_bucket = 'https://s3.amazonaws.com/sidearm.sites';

        this.get_data();


        this.has_visited = this.$cookie.get('has_visited');
    },

    mounted() {
        this.$cookie.set('has_visited', true, {expires: '1h'});
    }
}
</script>

<style lang="scss">
    @import "@/styles/global";
    @import "@/styles/imports";

    #app {position: relative;}

    body{
        :-webkit-scrollbar {
            width: 0px;  /* remove scrollbar space */
            background: transparent;  /* optional: just make scrollbar invisible */
        }
        -ms-overflow-style: none;
    }
    //html,body{overflow:hidden !important;}

    .overlay-top, .overlay-bottom{
        z-index:9999;
        background:#111 !important;
    }

   
</style> 
